import React from "react";
import "./Support.css";
import SiteHeader from "./../../components/SiteHeader";
import ContactForm from "./../../components/ContactForm";

const Support = () => {
  return (
    <main className="support" data-testid="support-root">
      <SiteHeader current="support" />

      {/* Hero */}
      <section className="support__hero container mt-5" data-testid="support-hero">
        <div className="support__intro">
          <h1 className="support__title">Ο Δρόμος προς τους Παραολυμπιακούς</h1>
          <h5>Το σημείο όπου η προσπάθεια συναντά το νόημα, ένα ύψιστο ιδανικό</h5>
        </div>

        <figure className="support__portrait">
          <img src="/images/profile2.jpg" alt="Συγκέντρωση και αποφασιστικότητα" />
          <figcaption>«Τίποτα δεν είναι αδύνατο όταν στο λέει η ψυχή σου»</figcaption>
        </figure>
      </section>

      {/* Story blocks (content-forward) */}
      <section className="support__donate container" data-testid="support-sections">
        <article className="card">
          <h2>Γιατί οι Παραολυμπιακοί</h2>
          <p>
            Οι Παραολυμπιακοί είναι κάτι περισσότερο από μια διοργάνωση· είναι μια σκηνή όπου η προσπάθεια συναντά το νόημα, ένα ιδανικό.
            Το να αγωνιστώ εκεί σημαίνει να σταθώ υπέρ της συμπερίληψης, να δείξω ότι η κίνηση και η δεξιοτεχνία δεν έχουν όρια
            όταν οδηγεί το πνεύμα και να μπορέσω να εμπνεύσω άλλους με αναπηρία να ακολουθήσουν τα όνειρά τους. Και το πιο σημαντικό να καταφέρει η χώρα να εκπροσωπηθεί σε παγκόσμιο επίπεδο.
          </p>
          <img src="images\paralimpik-logo.svg" alt="Η Καϊπη Μαρία Ισμήνη σε προπόνηση με τον ομοσπονδιακό προπονητή Σωτήρη Ζήκο" />
        </article>

        <article className="card">
          <h2>Προπόνηση & Καθημερινή Δουλειά</h2>
          <p>
            Η εβδομάδα μου είναι δομημένη γύρω από μπλοκ προπονήσεων, ενδυνάμωσης, αποκατάστασης και ανάλυσης αγώνων υπό την στενή καθοδήγηση του ομοσπονδιακού προπονητή Σωτήρη Ζήκου.
            Κάποιες μέρες είναι δύσκολες· όλες όμως έχουν σκοπό.
          </p>
          <p>
            Η πρόοδος δεν είναι πάντα ένα βάθρο. Είναι η υπομονή να επαναλαμβάνεις μια άσκηση 200 φορές μέχρι να γίνει ένστικτο.
          </p>
          <img src="/images/maria_zhkos.jpg" alt="Η Καϊπη Μαρία Ισμήνη σε προπόνηση με τον ομοσπονδιακό προπονητή Σωτήρη Ζήκο" />
        </article>
      </section>

      {/* <section className="support__why container" data-testid="support-why">
        <h2>Τι Με Κρατάει σε Κίνηση</h2>
        <ul>
          <li>Η πίστη ότι η εκπροσώπηση έχει σημασία — μέσα κι έξω από το τραπέζι.</li>
          <li>Η χαρά του να μαθαίνεις τεχνικές λεπτομέρειες και να τις μετατρέπεις σε ροή.</li>
          <li>Η κοινότητα: προπονητές, συναθλητές, φίλοι και όλοι όσοι στέλνουν έναν καλό λόγο.</li>
          <li>Οι στιγμές που μετατρέπουν τον φόβο σε θάρρος — ένα ράλι τη φορά.</li>
        </ul>
      </section> */}

      <section className="support__intro mt-5 container" data-testid="support-share">
        <h1><strong>Τρόποι να Σταθείτε Δίπλα Μου</strong></h1>
        <h5 style={{fontWeight:"400",lineHeight:"1.6"}}>
          Είναι απαραίτητη η επανένταξή μου στην παγκόσμια κατάταξη μετά από δύο χρόνια απουσίας από τη διεθνή σκηνή λόγω μη οικονομικής δυνατότητας.
           Αυτό συνεπάγει την επανένταξή μου στην Εθνική Ομάδα και ίσως πιθανή περαιτέρω χρηματοδότηση για επιπλέον συμμετοχές σε τουρνουά.
        </h5>
       <h5 style={{fontWeight:"400",lineHeight:"1.6"}}> Κάθε συνεισφορά, μικρή ή μεγάλη, με φέρνει πιο κοντά στο όνειρό μου.</h5>
      </section>

      <section className="support__contact container" data-testid="support-contact">
        <div className="card contact-card">
          <h2>Επικοινωνία</h2>
          <div className="row">
            <div class="col">
            <ContactForm />
            </div>
            <div class="col"> 
              <div style={{marginTop:"2rem"}}>
                Τηλέφωνο: +30 6955176859
                </div>
                <div style={{marginTop:"1rem"}}>
Πάτρα, Αχαΐας                </div>
            </div>
          </div>
        </div>
      </section>


    </main>
  );
};

export default Support;
